import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import { Box, HBox, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import Spacer from "@ui/spacer/Spacer";
import { Rows } from "@ui/table/Rows";
import { Typo } from "@ui/text/Typo";
import { useEffect, useState } from "react";
import { GD } from "src/GD";
import { useRouter } from "src/services/Router";
import { notify } from "../../../tools/notify";
import { IAcquirerChannel, ITerminal } from "src/types/types";
import { S_ADD_CHANNEL_POPUP } from "src/view/popup/AddChannelPopup";
import { S_CONFIRM } from "src/view/popup/general/ConfirmDialog";
import { TerminalBadge } from "../TerminalBadge";
import { S_ADD_TERMINAL_POPUP } from "src/view/popup/AddTerminalPopup";
import { S_MERCHANT_TERMINAL_POPUP } from "src/view/popup/MerchantTerminalPopup";

export interface IMerchantChannelsProps {
	merchantId: number;
	clientId: number;
	terminalId?: number;
	internal?: boolean;
	readOnly?: boolean;
}

export const MerchantChannels = ({ merchantId, clientId, internal, terminalId, readOnly = false }: IMerchantChannelsProps) => {
	useLocale();
	const router = useRouter();
	const [channelsByTerminal, setChannelsByTerminal] = useState<[ITerminal, IAcquirerChannel[]][]>();

	//!TODO: busy;
	const [channels, setChannels] = useState<IAPIResponse<IAcquirerChannel[]>>();

	//const [terminals] = GD.B_TERMINALS.use();
	const [attachedTerminals, _attachedTerminalsBusy] = GD.B_MERCHANT_ATTACHED_TERMINALS.use({ merchantID: merchantId }, undefined, []);

	useEffect(() => {
		loadChannels();
	}, []);

	const loadChannels = async () => {
		const res = await GD.REQ_MERCHANT_ATTACHED_CHANNELS.request({ merchantID: merchantId, terminalId: terminalId });
		setChannels(res);
	};

	useEffect(() => {
		if (channels && channels.data && attachedTerminals?.data) {
			const unique = [...new Set(channels.data.map(item => item.terminal_id))];
			const channelsByTerminals: [ITerminal, IAcquirerChannel[]][] = [];

			for (let index = 0; index < unique.length; index++) {
				const currentTerminalId = unique[index];
				const terminal = attachedTerminals.data?.find(t => t.id === currentTerminalId);
				if (terminal) {
					const channelsLocal = channels.data.filter(c => c.terminal_id === terminal.id);
					if (channelsLocal && channelsLocal.length > 0) {
						channelsByTerminals.push([terminal, channelsLocal]);
					}
				}
			}
			setChannelsByTerminal(channelsByTerminals);
		}
	}, [channels, attachedTerminals]);

	const onAdd = async () => {
		const attachedTerminals = await GD.B_MERCHANT_ATTACHED_TERMINALS.execute({ merchantID: merchantId });

		if (attachedTerminals?.data) {
			if (attachedTerminals.data.length > 0) {
				S_ADD_CHANNEL_POPUP.invoke({
					merchantID: merchantId,
					onSuccess: () => {
						loadChannels();
					},
				});
			} else {
				S_CONFIRM.invoke({
					message: msg("thereAreNoTerminalsInTheMerchantDoYouWantToAddOne"),
					reject: "Cancel",
					confirm: msg("addTerminal"),
					onResult: (val: "confirm" | "reject") => {
						if (val === "confirm") {
							S_ADD_TERMINAL_POPUP.invoke({
								merchantID: merchantId,
								onSuccess: () => {
									GD.B_MERCHANT_ATTACHED_TERMINALS.execute({
										merchantID: merchantId,
									});
								},
							});
						}
					},
				});
			}
		}
	};

	const removeChannel = async (id: number) => {
		//!TODO: loader;
		S_CONFIRM.invoke({
			message: msg("areYouSure"),
			reject: "Cancel",
			onResult: (val: "confirm" | "reject") => {
				if (val === "confirm") {
					onChannelRemoveConfirm(id);
				}
			},
		});
	};

	const onChannelRemoveConfirm = async (id: number) => {
		//!TODO: loader;
		const res = await GD.REQ_MERCHANT_REMOVE_CHANNEL.request({
			channelID: id,
			merchantID: merchantId,
		});
		//!TODO:;
		if (res) {
			notify.info(msg("removed"));
			loadChannels();
		}
	};

	return (
		<VBox gap="10px">
			{merchantId !== 0 && !readOnly && (
				<HBox>
					<Spacer grow />
					<Button onClick={onAdd} title={msg("addChannel_ad6357a1")} variant="primarySmall" />
				</HBox>
			)}

			<VBox gap="20px">
				{channelsByTerminal &&
					channelsByTerminal.map(([terminal, channelsLocal]) => (
						<VBox gap="20px" key={terminal.id}>
							<VBox gap="5px">
								<Rows<ITerminal>
									internal={internal}
									data={[terminal]}
									gridTemplateColumns="auto max-content max-content"
									order={["type", "id"]}
									onClick={
										readOnly
											? undefined
											: row =>
													S_MERCHANT_TERMINAL_POPUP.invoke({
														clientId: clientId,
														merchantId: merchantId,
														merchantTerminal: row,
													})
									}
									cellFactory={(row, cell, _index, _key, name, sx, _expanded, _rowID) => {
										if (sx) {
											//sx.display = "flex";

											sx.backgroundColor = "#b0bbca";
										}

										if (name === "type") {
											sx && (sx.padding = 0);
											sx && (sx.paddingLeft = "12px");
											return {
												content: (
													<HBox gap="12px" sx={{ alignItems: "center" }}>
														<TerminalBadge terminal={row} />
														<Typo>{row.name}</Typo>
													</HBox>
												),
												sx,
											};
										}

										return { content: cell };
									}}
									menu={readOnly ? undefined : [
										// {
										// 	title: "View",
										// 	id: "view",
										// },
										{
											title: msg("view"),
											id: "view",
										},
									]}
									onMenuClick={readOnly ? undefined : (id, row, _rowID) => {
										if (id === "view") {
											router.navigate("terminal", { tid: row.id + "" });
										}
										// if (id === "remove") {
										// 	//!TODO: loader and so on;
										// 	removeTerminal(row);
										// }
										// if (id === "restore") {
										// 	restoreTerminal(row.id);
										// }
										// if (id === "view") {
										// 	// router.navigate("channel", {
										// 	// 	chid: row.id + "",
										// 	// 	mid: row.group_id + "",
										// 	// 	cid: row.client_id + "",
										// 	// });
										// 	return;
										// }
									}}
								/>

								<Box sx={{ paddingLeft: "30px" }}>
									<Rows
										itemType={"channel"}
										//	order={["__itemType", "status", "title", "terminal", "__actions"]}
										order={["__itemType", "status", "title", "__actions"]}
										internal={internal}
										// data={channelsLocal.map(m => {
										// 	return {
										// 		...m,
										// 		terminal: terminals?.data?.find(t => t.id === m.terminal_id)?.name,
										// 	};
										// })}
										data={channelsLocal}
										onClick={readOnly ? undefined : (row: IAcquirerChannel & { terminal?: string }) => {
											router.navigate("merchantchannel", {
												chid: row.link_id + "",
												mid: merchantId + "",
												cid: clientId + "",
											});
										}}
										menu={readOnly ? undefined : [
											{
												title: msg("remove"),
												id: "remove",
											},
										]}
										onMenuClick={readOnly ? undefined : (id, row, _rowID) => {
											if (id === "remove") {
												removeChannel(row.id);
											}
										}}
									/>
								</Box>
							</VBox>
						</VBox>
					))}
			</VBox>
		</VBox>
	);
};
